import { Calendar, Menu, Trophy, Users, X } from 'lucide-react';
import type { ChampionshipDto } from 'modules/client/tournaments/domain/types/dtos';
import getYearText from 'modules/client/tournaments/domain/utils/get-year-text';
import React, { useState } from 'react';

interface HeaderProps {
  activeTab: string;
  setActiveTab: (tab: string) => void;
  championship?: ChampionshipDto | null;
}

const Header: React.FC<HeaderProps> = ({ activeTab, setActiveTab, championship }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const menuItems = [
    { id: 'stages', label: 'Этапы', icon: Trophy },
    // { id: 'standings', label: 'Общая таблица', icon: Trophy },
    // { id: 'groups', label: 'Группы', icon: Grid3X3 },
    // { id: 'bracket', label: 'Плей-офф', icon: Target },
    { id: 'fixtures', label: 'Матчи', icon: Calendar },
    { id: 'teams', label: 'Команды', icon: Users },
  ];

  const yearText = getYearText(championship?.startDate, championship?.endDate);

  return (
    <header className="sticky top-0 z-50 bg-white shadow-md">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between py-4">
          <div className="flex items-center space-x-3">
            <div className="text-2xl">⚽</div>
            <div>
              <h1 className="text-xl font-bold text-gray-900">{championship?.tournament.name ?? 'Неизвестный организатор'}</h1>
              <p className="text-sm text-gray-600">
                {championship?.name ?? 'Неизвестный турнир'} {yearText}
              </p>
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden space-x-6 lg:flex">
            {menuItems.map((item) => {
              const Icon = item.icon;
              return (
                <button
                  key={item.id}
                  onClick={() => setActiveTab(item.id)}
                  className={`flex items-center space-x-2 rounded-lg px-3 py-2 text-sm transition-colors ${activeTab === item.id ? 'bg-emerald-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
                >
                  <Icon size={16} />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </nav>

          {/* Mobile Menu Button */}
          <button className="rounded-lg p-2 hover:bg-gray-100 lg:hidden" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="border-t border-gray-200 py-4 lg:hidden">
            <nav className="space-y-2">
              {menuItems.map((item) => {
                const Icon = item.icon;
                return (
                  <button
                    key={item.id}
                    onClick={() => {
                      setActiveTab(item.id);
                      setIsMenuOpen(false);
                    }}
                    className={`flex w-full items-center space-x-3 rounded-lg px-3 py-2 transition-colors ${activeTab === item.id ? 'bg-emerald-600 text-white' : 'text-gray-700 hover:bg-gray-100'}`}
                  >
                    <Icon size={18} />
                    <span>{item.label}</span>
                  </button>
                );
              })}
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
